import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Builds the E.164 value sent to Stytch from a dial code and the raw
 * national digits the user typed (or autofill inserted).
 *
 * Stytch keys users on the exact E.164 string and does not canonicalize
 * trunk prefixes: sending "+112125550123" (US trunk "1" kept by contact
 * autofill) or "+330612345678" (FR trunk "0") creates a separate duplicate
 * Stytch user while the carrier still delivers the OTP to the real handset.
 * Parsing the naive `${dialCode}${digits}` concatenation through
 * libphonenumber strips the trunk digit and yields the canonical E.164
 * string. When the candidate is unparseable, fall back to it unchanged so
 * Stytch rejects it with invalid_phone_number and the screen surfaces the
 * existing invalid-phone copy.
 */
export function toE164PhoneNumber(
  dialCode: string,
  nationalDigits: string,
): string {
  const candidate = `${dialCode}${nationalDigits}`;
  return parsePhoneNumberFromString(candidate)?.number ?? candidate;
}
